
import { ref, defineComponent, onMounted, nextTick, watch } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'FaqLists',
  props: {
    list: {
      type: Object
    },
    isEvents: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isOpened = ref(false)

    const toggleAccordion = () => {
      isOpened.value = !isOpened.value
    }
    const route = useRoute()

    const accordion = {
      beforeEnter(el: any) {
        el.style.height = '0'
      },
      enter(el: any) {
        el.style.height = el.scrollHeight + 'px'
      },
      beforeLeave(el: any) {
        el.style.height = el.scrollHeight + 'px'
      },
      leave(el: any) {
        el.style.height = '0'
      }
    }
    const scrollToHash = async () => {
      const targetId = route.hash
      if (!targetId) return
      if (!!props.list && `#post_id_${props.list.id}` == targetId) {
        isOpened.value = true
      }
      await nextTick()
      const targetEl = document.querySelector(targetId) as HTMLElement

      const targetOffsetTop =
        targetEl.getBoundingClientRect().top + window.scrollY

      targetEl.querySelector('dd')?.addEventListener('transitionend', () => {
        window.scrollTo({ top: targetOffsetTop })
      })
    }
    onMounted(() => {
      scrollToHash()
    })

    watch(
      () => route.hash,
      () => {
        isOpened.value = false
        nextTick(() => {
          scrollToHash()
        })
      }
    )

    return {
      isOpened,
      toggleAccordion,
      accordion
    }
  }
})
